import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import {StyleRoot} from 'radium';
import '../../../libraries';

import * as styles from '../../../styles';
import PrintQuestionsReport from './print_school_questions.js';

var gettext = window.gettext ;
export default class QuestionsReport extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        printing: false,
        class: 'school',
        subject: 'all',
    }

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.print && this.state.print) {
            window.scrollTo(0, 0);
            window.print();
            this.setState({print: false});
        }
    }

    render() {
        const subjects = _.mapKeys(this.props.examination.subjects, item => item.id);
        const rootSubjects = _.uniq(_.union(..._.map(
            this.props.examination.questions,
            item => _.map(item.subjects, item => item.root_subject),
        )));
        const questions = _.sortBy(this.props.examination.questions, 'index');
        const Td = props => <td {...props} style={{...styles.softTd, ...(props.style || {})}}>{props.children}</td>;
        const Mtd = props => <td {...props} style={{...styles.softTd, textAlign: 'center', ...(props.style || {})}}>
            {props.children}
        </td>;
        const Th = props => <th {...props} style={{...styles.softTh, ...(props.style || {})}}>{props.children}</th>;
        const Mth = props => <th {...props} style={{...styles.softTh, textAlign: 'center', ...(props.style || {})}}>
            {props.children}
        </th>;
        return <span>
            <div style={{marginBottom: '.5em', display: 'inline-block', width: '100%'}}>
                <iframe
                    ref='print'
                    style={{width: '0', height: '0', border: 'none'}}
                    srcDoc={`<html>
    <head>
        <link rel="stylesheet" type="text/css" href="/css/mhelli.css">
        <style>
            @page {
                size: A4 Portrait;
                margin: 0;
            }
            body {
                background-color: white;
            }
        </style>
    </head>
    <body dir='rtl'>
        <span id='content'>
            <span style='font-family: IRANSans;'>1</span>
            <span style='font-family: IRANSans; font-weight: 700;'>1</span>
        </span>
    </body>
</html>`}/>
                <button
                    key='print'
                    style={{
                        ...styles.defaultButton,
                        float: 'left',
                        marginRight: '.5em',
                        backgroundColor: styles.fourthColor,
                    }}
                    onClick={async () => {
                        this.setState({printing: true});
                        const win = this.refs.print.contentWindow;
                        win.document.getElementById('content').innerHTML = '';
                        ReactDom.render(<StyleRoot>
                            <PrintQuestionsReport
                                imageLoaded={() => {
                                    win.print();
                                    this.setState({printing: false});
                                }}
                                last
                                school={this.props.school}
                                data={this.props.data}
                                examination={this.props.examination}
                                subject={this.state.subject}
                                class={this.state.class}
                                className={this.state.className}
                            />
                        </StyleRoot>, win.document.getElementById('content'));
                    }}>
                    {window.gettext('Print')}
                </button>
                {window.gettext('Choose class')}:&nbsp;
                {_.map(
                    _.filter(
                        this.props.school.classes,
                        clazz => _.some(this.props.data, d => d.clazz === clazz.id),
                    ),
                    clazz => <button
                        key={'class-' + clazz.id}
                        style={{
                            ...(this.state.class === clazz.id
                                ? styles.activeButton
                                : styles.button),
                            marginLeft: '.5em',
                        }}
                        onClick={() => this.setState({class: clazz.id, className: clazz.name})}>
                        {clazz.name.persian()}
                    </button>,
                )}
                <button
                    key='school'
                    style={this.state.class === 'school' ? styles.activeButton : styles.button}
                    onClick={() => this.setState({class: 'school', className: window.gettext('School')})}>
                    {window.gettext('All Classes')}
                </button>
                <div style={{height: '2em', clear: 'right'}}></div>
                <button
                    key='all'
                    style={
                        this.state.subject === 'all'
                            ? styles.activeTabButton
                            : styles.tabButton
                    }
                    onClick={() => this.setState({subject: 'all', subjectName: window.gettext('All')})}>
                    {window.gettext('All')}
                </button>
                {_.map(rootSubjects, subject => <button
                    key={'subject-' + subject}
                    style={{
                        ...(this.state.subject === subject
                            ? styles.activeTabButton
                            : styles.tabButton),
                    }}
                    onClick={() => this.setState({subject: subject, subjectName: subjects[subject].title})}>
                    {subjects[subject].title.persian()}
                </button>)}
            </div>
            <div
                style={{
                    ...styles.box,
                    width: '100%',
                    overflow: 'hidden',
                }}>
                <div style={{float: 'right', width: '25%'}}>
                    {window.gettext('Examination')}: {this.props.examination.title}
                </div>
                <div style={{float: 'right', width: '25%'}}>
                    {window.gettext('School Name')}: {this.props.school.name}
                </div>
                <div style={{float: 'right', width: '25%'}}>
                    {window.gettext('City')}: {this.props.school.city.name}
                </div>
                <div style={{float: 'right', width: '25%'}}>
                    {window.gettext('Grade')}: {this.props.examination.grades[0].title}
                </div>
                <div style={{float: 'right', width: '25%'}}>
                    {window.gettext('Holding Date')}: {this.props.examination.date.toJalali().persian()}
                </div>
                <div style={{float: 'right', width: '25%'}}>
                    {window.gettext('Centers Participated')}:
                    &nbsp;
                    {(this.props.examination.schools_participated || '').persian()}
                </div>
                <div style={{float: 'right', width: '25%'}}>
                    {window.gettext('Participants')}: {(this.props.examination.students_participated || '').persian()}
                </div>
            </div>
            <div
                style={{
                    ...styles.box,
                    marginTop: '1em',
                    width: '100%',
                    display: 'inline-block',
                }}>
                <div
                    style={{
                        width: '100%',
                        boxSizing: 'border-box',
                        padding: '1em',
                        textAlign: 'center',
                    }}>
                    <table
                        style={{
                            borderCollapse: 'collapse',
                            width: '100%',
                            border: '.0625em solid #eaeaea',
                        }}>
                        <thead>
                            <tr>
                                <Th rowSpan='2'>{window.gettext('Question')}</Th>
                                <Th rowSpan='2'>{window.gettext('Subject')}</Th>
                                <Mth rowSpan='2'>{window.gettext('Total Score')}</Mth>
                                <Mth
                                    colSpan='2'
                                    style={{borderRight: '.0625em solid #cacaca'}}>
                                    {window.gettext('Average')}
                                </Mth>
                            </tr>
                            <tr>
                                <Mth style={{borderRight: '.0625em solid #cacaca'}}>
                                    {this.state.class === 'school'
                                        ? window.gettext('School')
                                        : window.interpolate(
                                            window.gettext('Class %(class)s'),
                                            {class: this.state.className},
                                            true,
                                        )
                                    }
                                </Mth>
                                <Mth>
                                    {window.gettext('Country')}
                                </Mth>
                            </tr>
                        </thead>
                        <tbody>
                            {_.map(
                                _.filter(questions, question => this.state.subject === 'all' || _.some(
                                    question.subjects,
                                    subject => subject.root_subject === this.state.subject,
                                )),
                                question => <tr key={question.id}>
                                    <Td>{(question.index + 1).persian()}</Td>
                                    <Td>
                                        {_.map(_.uniq(_.union(..._.map(
                                            question.subjects,
                                            item => _.reverse(_.slice(item.subjects)),
                                        ))), item => subjects[item].title).join(' - ')}
                                    </Td>
                                    <Mtd>
                                        {_.sumBy(question.scores, 'score').toFixed(2).persian(true)}
                                    </Mtd>
                                    <Mtd style={{borderRight: '.0625em solid #cacaca'}}>
                                        {(_.find(this.props.data, data => (
                                            data.question == question.id &&
                                            data.field == 21 &&
                                            (
                                                this.state.class === 'school'
                                                ? data.school === this.props.school.id
                                                : data.clazz === this.state.class
                                            )
                                        )) || {value: 0}).value.toFixed(2).persian(true)}
                                    </Mtd>
                                    <Mtd>
                                        {(_.find(this.props.data, data => (
                                            data.question == question.id &&
                                            data.field == 21 &&
                                            data.is_global
                                        )) || {value: 0}).value.toFixed(2).persian(true)}
                                    </Mtd>
                                </tr>,
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </span>;
    }
}
